import { ON_HOLD } from '../constants/kycStatus';
const KycError = () => (
  <div className="kyc-error">
    <p>{ON_HOLD.message}</p>
    <style jsx>{`
      .kyc-error {
        padding: 50px 30px;
      }
      p {
        font-size: 18px;
        color: #333;
        -webkit-font-smoothing: antialiased;
        letter-spacing: 1px;
        font-weight: bold;
      }
    `}</style>
  </div>
);

export default KycError;



// WEBPACK FOOTER //
// ./components/kycError.tsx